module.exports = __webpack_public_path__ + "img/1402.2045381d.jpg";